import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCommentAddComponent } from "./med-icon-comment-add.component";

@NgModule({
  declarations: [
    MedIconCommentAddComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCommentAddComponent,
  ],
})
export class MedIconCommentAddModule { }
